import React from 'react'
import type { FeedItem } from '../../Api'
import { HeadlineItem, HeadlinesContainer, HeadlineText, IconContainer } from './styles'
import { Lk } from 'Components/Links/Lk'
import { ArticleIcon } from 'Components/Icons'
import { colors } from 'Components/consts'

type FeedHeadlineListProps = {
  feedItems: FeedItem[]
  handleItemClick: (item: FeedItem, index: number) => void
}

export const FeedHeadlineList: React.FC<
  React.PropsWithChildren<FeedHeadlineListProps>
> = ({ feedItems, handleItemClick }) => {
  return (
    <HeadlinesContainer>
      {feedItems.map((headline, index) => (
        <HeadlineItem key={headline.id}>
          <IconContainer>
            <ArticleIcon width={12} height={15} fill={colors.gray.gray70} />
          </IconContainer>
          <Lk
            link={headline.shareLink || headline.itemLink || '#'}
            alt={headline.title || ''}
            onBeforeNavigate={() => handleItemClick(headline, index)}
            awaitBeforeNavigate={true}
          >
            <HeadlineText>{headline.title}</HeadlineText>
          </Lk>
        </HeadlineItem>
      ))}
    </HeadlinesContainer>
  )
}
